import { FC, useState } from 'react';
import { useDeletePastPaper, AdminPastPaper } from '@/api/useAdminPastPapers';
import AdminConfirmModal from '@/components/admin/AdminConfirmModal';

type DeletePastPaperButtonProps = {
  paper: AdminPastPaper;
};

const DeletePastPaperButton: FC<DeletePastPaperButtonProps> = ({ paper }) => {
  const [isOpen, setIsOpen] = useState(false);
  const deleteMutation = useDeletePastPaper();

  const handleDeleteConfirm = () => {
    deleteMutation.mutate(paper.id, {
      onSuccess: () => {
        setIsOpen(false);
      },
    });
  };

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="text-red-400 font-medium hover:text-red-500 transition-colors"
      >
        Delete
      </button>

      <AdminConfirmModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onConfirm={handleDeleteConfirm}
        variant="warning"
        title="Delete Past Paper"
        message={
          <>
            Are you sure you want to delete <span className="font-medium">"{paper.title}"</span>?
          </>
        }
        warning="This will permanently delete all questions linked to this paper and all student attempts."
        confirmText="Delete"
        isLoading={deleteMutation.isPending}
      />
    </>
  );
};

export default DeletePastPaperButton;
